export const AVAILABLE_COMMUNICATION_BOARD_SECTIONS = [
  'supplier_status',
  'additional_sales_status',
  'important_info',
]